import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

// Import all components
import Header from './frontend/components/Header';
import Hero from './frontend/components/Hero';
// import Solutions from './frontend/components/Solutions';
// import Counter from './frontend/components/Counter';
import Products from './frontend/components/Products';
// import Developer from './frontend/components/Developer';
// import Sectors from './frontend/components/Sectors';
// import Partners from './frontend/components/Partners';
import Contact from './frontend/components/Contact';
import FAQ from './frontend/components/FAQ';
import Footer from './frontend/components/Footer';

// 👇 IMPORT THE NEW COMPONENT
import PrivacyConsent from './components/PrivacyConsent'; 

import 'primereact/resources/themes/lara-light-indigo/theme.css'; 
import 'primereact/resources/primereact.min.css'; 
import 'primeicons/primeicons.css'; 
import PlanCategories from './frontend/components/PlanCategories';
import WhatsAppChat from './frontend/components/WhatsAppChat';

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <div className="App restaurant-website">
      <div className="offcanvas__overlay"></div>
      
      <Header />
      
      <main>
        <Hero />
        {/* <Solutions />
        <Counter /> */}
        {/* <Products /> */}

        <PlanCategories/>
        {/* <Developer />
        <Sectors />
        <Partners /> */}
        <Contact />
        <FAQ />
      </main>
      
      <Footer />
      
      {/* 👇 ADD THE CONSENT POPUP HERE */}
      <PrivacyConsent />
      
       {/* 👇 ADD WHATSAPP & CHATBOT HERE */}
      <WhatsAppChat />

      <div className="back-to-top"><i className="fa fa-angle-up"></i></div>

      {/* Custom CSS for Orange Theme & Privacy Popup */}
      <style>{`
        /* --- ADD THIS INSIDE THE <style> TAG IN App.js --- */
.back-to-top{
   top: 50p important;
}
.privacy-consent-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(4px);
}

.privacy-consent-box-large {
  background: white;
  padding: 0;
  border-radius: 16px;
  box-shadow: 0 20px 50px rgba(0,0,0,0.2);
  max-width: 600px;
  width: 90%;
  overflow: hidden;
  animation: zoomIn 0.3s ease-out;
  position: relative;
}

@keyframes zoomIn {
  from { transform: scale(0.9); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

.privacy-header {
  background: var(--orange-light);
  padding: 25px 30px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.privacy-header h3 {
  margin: 0;
  color: #333;
  font-size: 22px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.privacy-header h3 i {
  color: var(--orange-primary);
  font-size: 24px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 28px;
  color: #999;
  cursor: pointer;
  line-height: 1;
}

.close-btn:hover {
  color: #333;
}

.privacy-body {
  padding: 30px;
}

.privacy-body p {
  font-size: 16px;
  color: #555;
  line-height: 1.6;
  margin-bottom: 20px;
}

.checkbox-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}

.checkbox-wrapper input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: var(--orange-primary);
  cursor: pointer;
}

.checkbox-wrapper label {
  font-size: 15px;
  color: #444;
  cursor: pointer;
  font-weight: 500;
}

.privacy-actions-large {
  padding: 20px 30px;
  background: #f9f9f9;
  display: flex;
  gap: 15px;
  justify-content: flex-end;
  border-top: 1px solid #eee;
}

.privacy-actions-large button {
  padding: 12px 25px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.btn-accept-large {
  background: var(--orange-primary);
  color: white;
  box-shadow: 0 4px 10px rgba(248, 148, 35, 0.3);
}

.btn-accept-large:hover {
  background: var(--orange-dark);
  transform: translateY(-1px);
}

.btn-decline-large {
  background: white;
  border: 1px solid #ddd;
  color: #555;
}

.btn-decline-large:hover {
  background: #f1f1f1;
  border-color: #ccc;
}

@media (max-width: 576px) {
  .privacy-consent-box-large {
    width: 95%;
    margin: 10px;
  }
  
  .privacy-header {
    padding: 20px;
  }
  
  .privacy-body {
    padding: 20px;
  }
  
  .privacy-actions-large {
    flex-direction: column-reverse;
    padding: 20px;
  }
  
  .privacy-actions-large button {
    width: 100%;
  }
}
      `}</style>
    </div>
  );
}

export default App;